import { createActions } from 'redux-actions';

export const {
  pastOrders: {
    setPeriod,
    fetchPastOrdersSettings,
    receivePastOrdersSettings,
    fetchStatus,
    receiveStatus,
    startSync,
    stopSync,
    setSelectedShops,
    receiveAnalyze,
  },
}: any = createActions({
  PAST_ORDERS: {
    SET_PERIOD: (period) => ({
      period,
    }),
    START_SYNC: () => ({
      syncInProgress: true,
      status: {
        inProgress: true,
      },
      pastOrders: {
        showInitial: false,
      }
    }),
    STOP_SYNC: () => ({
      syncInProgress: false,
    }),
    FETCH_PAST_ORDERS_SETTINGS: () => ({
      isFetchingPastOrdersSettings: true,
    }),
    RECEIVE_PAST_ORDERS_SETTINGS: (config, businessUnitId, invitationSettings, features) => ({
      productReviewsEnabled: config.enableProductReviews,
      pastOrders: config.pluginSettings ? config.pluginSettings.pastOrders : {},
      businessUnitId,
      invitationSettings,
      isFetchingPastOrdersSettings: false,
      features,
    }),
    FETCH_STATUS: (businessUnitId) => ({
      businessUnitId,
      isFetching: true,
    }),
    RECEIVE_STATUS: (status) => ({
      isFetching: false,
      status,
    }),
    SET_SELECTED_SHOPS: (selectedShops) => ({
      selectedShops,
    }),
    RECEIVE_ANALYZE: (analyze) => ({
      analyze,
    }),
  },
});
